import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface StepCardProps {
  action?: () => void;
  children?: React.ReactNode;
  containerClassNames?: string;
  headerClassNames?: string;
  headerContent?: React.ReactNode;
  isShowing?: boolean;
  metadata?: React.ReactNode;
  stepCardClassNames?: string;
  stepNumber: number;
  thumbnail?: string;
  title: string;
  dataTestId?: string;
}

const StepCard: React.FC<StepCardProps> = ({
  action,
  children,
  containerClassNames,
  headerClassNames,
  headerContent,
  isShowing = true,
  metadata,
  stepCardClassNames,
  stepNumber,
  thumbnail,
  title,
  dataTestId,
}) => {
  const stepCardContainer = twMerge(
    'flex',
    'grow',
    'group',
    'items-center',
    'min-h-[100px]',
    'p-3',
    'md:p-6',
    'md:space-x-6',
    'rounded-xl',
    'space-x-4',
    'bg-white',
    'cursor-pointer',
    'border',
    'border-kira-slate-200',
    'hover:border-kira-blue-800',
    'transition-colors',
    'duration-200',
    'ease-in-out',
    stepCardClassNames ?? ''
  );

  const stepNumberContainer = twMerge(
    'flex-none',
    'w-8',
    'h-8',
    'leading-8',
    'text-center',
    'rounded-full',
    'bg-kira-slate-200',
    'body-sm-reg'
  );

  const detailsContainer = twMerge('flex', 'flex-col', 'gap-2', 'w-full');

  const headerContainer = twMerge(
    'flex',
    'text-left',
    'justify-between',
    'prose-title-h4',
    'items-center',
    headerClassNames ?? ''
  );

  const cardContainer = twMerge(
    'flex',
    'items-center',
    containerClassNames ?? ''
  );

  const clickCard = () => {
    if (!action) {
      return;
    }
    action();
  };

  return isShowing ? (
    <div className={cardContainer}>
      <div className="pr-4">
        <div className={stepNumberContainer}>{stepNumber}</div>
      </div>
      <button
        className={stepCardContainer}
        type="button"
        onClick={clickCard}
        data-testid={dataTestId}
      >
        {thumbnail && (
          <img
            src={thumbnail}
            alt="thumbnail"
            className="-my-2 -mr-2 h-16 w-16 rounded object-cover"
          />
        )}
        <div className={detailsContainer}>
          <div className={headerContainer}>
            <div className="flex flex-col space-y-2">
              <div>{title}</div>
              {metadata}
            </div>
            {headerContent}
          </div>
          {!!children && children}
        </div>
      </button>
    </div>
  ) : null;
};

export default StepCard;
